/**
 * Maps each NodeType to the Zod schema its form uses for validation.
 * Single source of truth reused by blueprint import validation, so a pasted/imported
 * diagram is held to the same field-level rules as manual editing in the drawer forms.
 */

import { breakerFormSchema } from "components/CC/Nodes/BreakerNode/Forms/formSchema";
import { endFormSchema } from "components/CC/Nodes/EndNode/Forms/formSchema";
import { httpFormSchema } from "components/CC/Nodes/HttpNode/Forms/formSchema";
import { httpMethodFormSchema } from "components/CC/Nodes/MethodNodes/Forms/formSchema";
import { mirrorFormSchema } from "components/CC/Nodes/MirrorNode/Forms/formSchema";
import { modifyFieldFormSchema } from "components/CC/Nodes/ModifyFieldNode/Forms/formSchema";
import { repeaterFormSchema } from "components/CC/Nodes/RepeaterNode/Forms/formSchema";
import { setFormSchema } from "components/CC/Nodes/SetNode/Forms/formSchema";
import { startFormSchema } from "components/CC/Nodes/StartNode/Forms/formSchema";
import { subScenarioFormSchema } from "components/CC/Nodes/SubScenarioNode/Forms/formSchema";
import { waitFormSchema } from "components/CC/Nodes/WaitNode/Forms/formSchema";
import { webhookFormSchema } from "components/CC/Nodes/WebhookNode/Forms/formSchema";
import { NodeType } from "components/CC/types/enums.ts";
import { z } from "zod";

export const NODE_FORM_DATA_SCHEMAS: Partial<Record<string, z.ZodTypeAny>> = {
    [NodeType.Start]: startFormSchema,
    [NodeType.End]: endFormSchema,
    [NodeType.Wait]: waitFormSchema,
    [NodeType.Repeater]: repeaterFormSchema,
    [NodeType.Breaker]: breakerFormSchema,
    [NodeType.Http]: httpFormSchema,
    [NodeType.Webhook]: webhookFormSchema,
    [NodeType.Set]: setFormSchema,
    [NodeType.Modify]: modifyFieldFormSchema,
    [NodeType.Mirror]: mirrorFormSchema,
    [NodeType.SubScenario]: subScenarioFormSchema,
    [NodeType.Methods]: httpMethodFormSchema,
};
